import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Button, Select, TextInput } from 'components';
import {
  STOCK_TYPE_OPTIONS,
  TStockForm,
  TStockFormValues,
} from './StockForm.types';

const StockForm: TStockForm = ({ onSubmit, isLoading = false }) => {
  const { handleSubmit, control } = useFormContext<TStockFormValues>();

  const onFormSubmit = (data: TStockFormValues) => {
    onSubmit(data);
  };

  return (
    <div className="admin-form">
      <form
        onSubmit={handleSubmit(onFormSubmit)}
        className="admin-form__form"
        noValidate
      >
        <div className="admin-form__form-content">
          <div className="admin-form__field">
            <Controller
              name="name"
              control={control}
              render={({ field, fieldState }) => (
                <TextInput
                  label="Name"
                  onChange={field.onChange}
                  value={field.value ?? ''}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  required
                />
              )}
            />
          </div>

          <div className="admin-form__field">
            <Controller
              name="variation"
              control={control}
              render={({ field, fieldState }) => (
                <TextInput
                  label="Variation"
                  onChange={field.onChange}
                  value={field.value ?? ''}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </div>

          <div className="admin-form__field">
            <Controller
              name="quantity"
              control={control}
              render={({ field, fieldState }) => (
                <TextInput
                  type="number"
                  label="Quantity"
                  onChange={(e) => {
                    const parsedValue = parseInt(e.target.value, 10);
                    field.onChange(Number.isNaN(parsedValue) ? 0 : parsedValue);
                  }}
                  value={field.value ?? 0}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  required
                />
              )}
            />
          </div>

          <div className="admin-form__field">
            <Controller
              name="type"
              control={control}
              render={({ field, fieldState }) => (
                <Select
                  options={STOCK_TYPE_OPTIONS}
                  label="Type"
                  value={field.value}
                  onChange={field.onChange}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  required
                />
              )}
            />
          </div>
        </div>

        <div className="admin-form__actions">
          <Button variant="contained" type="submit" disabled={isLoading}>
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default StockForm;
